const translations = {
  ACCEPTANCE: 'Αποδοχή',
  ACCEPTED_OFFER: 'Αποδεχθείσα Προσφορά',
  ACTIVATION: 'Ενεργοποίηση',
  ACTIVATE_DEACTIVATE: 'Ενεργοποίηση\\Απενεργοποίηση',
  ACTIVE: 'Ενεργός',
  ACTIVE_C: 'ΕΝΕΡΓΟΣ',
  ACTIVE_FEM: 'Ενεργή',
  ACTIVE_PL: 'Ενεργοί',
  ACTIVE_PL_FEM: 'Ενεργές',
  ACTIVΙΤΥ: 'Δραστηριότητα',
  ADDITION: 'Προσθήκη',
  ADDRESS: 'Διεύθυνση',
  ADDRESSES: 'Διευθύνσεις',
  AGENT_C: 'ΑΝΤΙΠΡΟΣΩΠΟΣ',
  ALL: 'Όλα',
  AMOUNT: 'Ποσό',
  AMOUNT_GREATER_THAN_ZERO: 'Το ποσό πρέπει να είναι μεγαλύτερο από μηδέν',
  AMOUNTS: 'Ποσά',
  APPS_MEMBERSHIPS: 'Εφαρμογες - Memberships',
  APPROVAL: 'Έγκριση',
  ARE_YOU_SURE: 'Είστε σίγουρος;',
  AUCTION_C: 'ΔΗΜΟΠΡΑΣΙΑ',
  AUCTION_CANCEL: 'Ακύρωση δημοπρασίας',
  AUCTION_CANCELED: 'Η δημοπρασία έχει ακυρωθεί',
  AUCTION_CANCEL_ALL: 'Μαζική Ακύρωση δημοπρασιών',
  AUCTION_CANCEL_FOR: 'Πρόκειται να ακυρώσετε τη δημοπρασία για ',
  AUCTION_CANCEL_ALL_ASK:
    'Πρόκειται να ακυρώσετε όλες τις επιλεγμένες δημοπρασίες.',
  AUCTION_CREATE_C: 'ΔΗΜΙΟΥΡΓΙΑ ΔΗΜΟΠΡΑΣΙΑΣ',
  AUCTION_DURATION: 'Διάρκεια Δημοπρασίας',
  AUCTION_ENDED: 'Η δημοπρασία έληξε',
  AUCTION_INFO: 'Πληροφορίες Δημοπρασίας',
  AUCTIONS_LOSING: 'Δημοπρασίες που χάνω',
  AUCTIONS_LOSING_C: 'ΔΗΜΟΠΡΑΣΙΕΣ ΠΟΥ ΧΑΝΩ',
  AUCTION_NOT_STARTED_YET: 'Η δημοπρασία δεν έχει ξεκινήσει ακόμη',
  AUCTION_SELECT_LOWEST_PRICES_ALL: 'Μαζική Επιλογή Προσφορών',
  AUCTION_SELECT_LOWEST_PRICES_ALL_ASK:
    'Πρόκειται να επιλέξετε τις χαμηλότερες προσφορές από τους επιλεγμένους τύπους ανταλλακτικών για όλες τις επιλεγμένες δημοπρασίες.',
  AUCTION_STATUS_CANCELED: 'Ακυρωμένη',
  AUCTION_STATUS_DELETED: 'Διεγραμμένη',
  AUCTION_STATUS_FINISHED: 'Ολοκληρωμένη',
  AUCTION_STATUS_FINISHING_IN: 'Λήγει σε ',
  AUCTION_STATUS_FOR_ACCEPTANCE: 'Προς Αποδοχή',
  AUCTION_STATUS_FOR_DELIVERY: 'Προς Παράδοση',
  AUCTION_STATUS_OVERDUE: 'Έληξε',
  AUCTION_STATUS_PENDING: 'Μη Ενεργοποιημένη',
  AUCTIONS: 'Δημοπρασίες',
  AUCTIONS_CHOSEN: 'Επιλεγμένες Δημ\\σίες',
  AUCTIONS_MY_C: 'ΟΙ ΔΗΜΟΠΡΑΣΙΕΣ ΜΟΥ',
  AUCTIONS_WINNING: 'Δημοπρασίες που κερδίζω',
  AUCTIONS_WINNING_C: 'ΔΗΜΟΠΡΑΣΙΕΣ ΠΟΥ ΚΕΡΔΙΖΩ',
  AUCTION_TITLE: 'Τίτλος',
  BASIC_INFO: 'Βασικά Στοιχεία',
  BRAND: 'Μάρκα',
  BRANDS: 'Μάρκες',
  CAN_ONLY_UPLOAD_FILES:
    'Είναι δυνατή η μεταφόρτωση των ακόλουθων τύπων αρχείων',
  CANCEL: 'Ακύρωση',
  CANCEL_C: 'ΑΚΥΡΩΣΗ',
  CANCELLATION: 'Ακύρωση',
  CATEGORY: 'Κατηγορία',
  CHANGE_C: 'ΑΛΛΑΓΗ',
  CHANGE_PASSWORD: 'Αλλαγή Κωδικού',
  CHANGE_PASSWORD_C: 'ΑΛΛΑΓΗ ΚΩΔΙΚΟΥ',
  CHARACTERISTICS: 'Χαρακτηριστικά',
  CHOOSE_EXISTING: 'Επιλογή Υπάρχοντος',
  CHOOSE_VALUE: 'Επιλέξτε τιμή',
  CITY: 'Πόλη',
  CLICKABLE_OFFERS: 'Clickable Προσφορές',
  CLOSE: 'Κλείσιμο',
  COMPLETED: 'Ολοκληρώθηκε',
  COMPLETED_PL_FEM: 'Ολοκληρωμένες',
  COMMENTS: 'Σχόλια',
  COMMUNICATION_NAME: 'Όν.Επικοινωνίας',
  COMMUNICATION_SURNAME: 'Επ.Επικοινωνίας',
  COPY: 'Αντιγραφή',
  COST_PER_FOLDER: 'Κόστος ανά Φάκελο',
  COUNTRY: 'Χώρα',
  CREATE_FROM: 'Δημιουργήθηκε από',
  CREATE_NEW: 'Δημιουργία Νέου',
  CREATE_NEW_FEM: 'Δημιουργία Νέας',
  CREATION_DATE: 'Ημ/νία Δημιουργίας',
  CURRENT: 'Τρέχουσες',
  CURRENT_AUCTIONS_C: 'ΤΡΕΧΟΥΣΕΣ ΔΗΜΟΠΡΑΣΙΕΣ',
  DASHBOARD: 'Επισκόπηση',
  DATAGRID_CHOOSE: 'Επιλέξτε',
  DATAGRID_FIRST: 'Πρώτη',
  DATAGRID_FROM_PAGE: 'από',
  DATAGRID_LAST_PAGE: 'Τελευταία',
  DATAGRID_NEXT_PAGE: 'Επόμενη',
  DATAGRID_NO_RESULTS: 'Δε βρέθηκαν αποτελέσματα',
  DATAGRID_PAGE: 'Σελίδα',
  DATAGRID_PREVIOUS_PAGE: 'Προηγούμενη',
  DATAGRID_RESULTS_PER_PAGE: 'Αποτελέσματα/Σελίδα',
  DATAGRID_RESULTS_UNTIL_PAGE: 'έως',
  DATAGRID_SEARCH: 'Αναζήτηση...',
  DATE: 'Ημερομηνία',
  DATE_FROM: 'Ημερομηνία Από',
  DATE_UNTIL: 'Ημερομηνία Εως',
  DATE_OVERDUE: 'Ημ/νία Λήξης',
  DAY: 'Ημέρα',
  DAYS: 'Ημέρες',
  DAYS_MISSING_ENDING: 'ημέρ',
  DAY_NO_ENDING: 'Ημέρ',
  DEACTIVATED: 'Ανενεργός',
  DEACTIVATION: 'Απενεργοποίηση',
  DELETE: 'Διαγραφή',
  DELETION: 'Διαγραφή',
  DELIVERY: 'Παράδοση',
  DEFAULT_INSURANCE_DAYS: 'Ημέρες Δημοπρ.',
  DESCRIPTION: 'Περιγραφή',
  DETAILS: 'Λεπτομέρειες',
  DIFFERENCE_FROM_INITIAL_PRICE: 'Διαφορά από Αρχική',
  DISPATCH: 'Αποστολή',
  DISPATCH_PROBLEM: 'Πρόβλημα Αποστολής',
  DISTINCTIVE_TITLE: 'Διακρ.Τίτλος',
  DOORS: 'Πόρτες',
  DRAG_FILES_HERE: 'Σύρετε αρχεία εδώ',
  DRAG_FILES_TO_AREA: 'Σύρετε τα αρχεία στην περιοχή',
  DURATION: 'Διάρκεια',
  EDIT: 'Επεξεργασία',
  EMAIL: 'Email',
  EMPTY: '<Κενό>',
  ENGINE_TYPE: 'Τύπος Κινητήρα',
  ENGINE_CAPACITY: 'Κυβισμός',
  END: 'Λήξη',
  ENDING_FEMALE_SINGULAR: 'α',
  ENDING_FEMALE_PLURAL: 'ες',
  EPICS_APP_SUCCESFUL_CHANGE_PASSWORD: 'Επιτυχής αλλαγή κωδικού.',
  EPICS_APP_SUCCESFUL_RESET_PASSWORD: 'Ο κωδικός έγινε reset.',
  EPICS_AUCTIONS_ACCEPTED_INSURANCE_OFFER:
    'Αποδεχθήκατε την προσφορά της ασφαλιστικής',
  EPICS_AUCTIONS_AUCTION_CANCELED: 'Η δημοπρασία ακυρώθηκε',
  EPICS_AUCTIONS_AUCTION_CREATED: 'Η δημοπρασία δημιουργήθηκε!',
  EPICS_AUCTIONS_AUCTION_EDITED: 'Επιτυχής επεξεργασία δημοπρασίας.',
  EPICS_AUCTIONS_AUCTION_STARTED: 'Η δημοπρασία ενεργοποιήθηκε',
  EPICS_AUCTIONS_FILE_LOAD: 'Το αρχείο φορτώθηκε',
  EPICS_AUCTIONS_LOWEST_PRICES_FROM_SELECTED:
    'Επιλέχθηκαν οι χαμηλότερες προσφορές των επιλεγμένων δημοπρασιών.',
  EPICS_AUCTIONS_OFFER_INSERTED: 'Η προσφορά καταχωρήθηκε',
  EPICS_AUCTIONS_OFFER_SELECTED: 'Η προσφορά επιλέχθηκε',
  EPICS_AUCTIONS_OFFER_REJECTED: 'Η προσφορά απορρίφθηκε',
  EPICS_AUCTIONS_SUCCESFUL_UPDATE: 'Επιτυχής ενημέρωση',
  EPICS_BIDS_BID_CANCELED: 'Η προσφορά ακυρώθηκε',
  EPICS_GARAGES_GARAGE_CREATED: 'Το συνεργείο δημιουργήθηκε',
  EPICS_GARAGES_GARAGE_UPDATED: 'Το συνεργείο επεξεργάστηκε',
  EPICS_GARAGES_GARAGE_DELETED: 'Το συνεργείο διαγράφηκε',
  EPICS_PARTIES_PARTY_CREATED: 'Το πρόσωπο δημιουργήθηκε',
  EPICS_PARTIES_PARTY_UPDATED: 'Το πρόσωπο επεξεργάστηκε',
  EPICS_PARTIES_PARTY_DELETED: 'Το πρόσωπο διαγράφηκε',
  EPICS_PARTIES_STATUS_UPDATE: 'Η κατάσταση άλλαξε',
  EXPERT: 'Εμπειρογνώμονας',
  EXPERT_SHORT: 'Εμπειρ\\μονας',
  EXPERTS: 'Εμπειρογνώμονες',
  FAX: 'Fax',
  FIELD_CANNOT_BE_EMPTY: 'Το πεδίο δε μπορεί να είναι άδειο',
  FINISHED: 'Αρχείο',
  FIRSTNAME: 'Όνομα',
  FOLDER_NO: 'Αρ.Φακέλου',
  FOLDER_NO_C: 'ΑΡ.ΦΑΚΕΛΟΥ',
  FOLDER_C: 'ΦΑΚΕΛΟΣ',
  FOLDER_COUNT: 'Αριθμός Φακέλων',
  FOLDER_DATA: 'Στοιχεία Φακέλου',
  FOR: 'για',
  FOR_ACCEPTANCE: 'Προς Αποδοχή',
  FOR_DISPATCH: 'Προς Παράδοση',
  FOR_SELECTION: 'Προς Επιλογή',
  FROM: 'Από',
  FROM_FILE: 'Από Αρχείο',
  GARAGE: 'ΣΥΝΕΡΓΕΙΟ',
  GARAGE_ASK_TO_CHOOSE: 'Παρακαλούμε επιλέξτε συνεργείο',
  GARAGE_C: 'ΣΥΝΕΡΓΕΙΟ',
  GARAGE_CHOOSE: 'Επιλογή Συνεργείου',
  GARAGE_CREATE: 'Δημιουργία Συνεργείου',
  GARAGE_DELETE: 'Διαγραφή συνεργείου',
  GARAGE_EDIT_C: 'ΕΠΕΞΕΡΓΑΣΙΑ ΣΥΝΕΡΓΕΙΟΥ',
  GARAGE_NEW_C: 'ΔΗΜΙΟΥΡΓΙΑ ΣΥΝΕΡΓΕΙΟΥ',
  GARAGES: 'Συνεργεία',
  GARAGE_TAX_NUMBER: 'ΑΦΜ Συνεργείου',
  GENERAL: 'Γενικά',
  GENERIC_ERROR: 'Παρουσιάστηκε κάποιο σφάλμα',
  HIDE: 'Απόκρυψη',
  HIDE_C: 'ΑΠΟΚΡΥΨΗ',
  HISTORY: 'Ιστορικό',
  HOURS: 'ώρες',
  HOURS_MISSING_ENDING: 'ώρ',
  IF_INSERTED_GARAGE:
    'Αν έχετε εισάγει το συνεργαζόμενο συνεργείο στο σύστημα, πληκτρολογήστε το ΑΦΜ του, αλλιώς καταχωρήστε το πατώντας το κουμπί.',
  IMAGES_UPLOAD: 'Ανέβασμα Φωτογραφιών',
  IMITATION_CATEGORY: 'Κατ. After Market',
  INACTIVE_C: 'ΑΝΕΝΕΡΓΟΣ',
  INITIAL_PRICE_SHORT: 'Αρχ.Τιμή',
  INPUT_DATA: 'Εισαγωγή Στοιχείων',
  INSURANCE: 'Ασφαλιστική',
  INSURANCE_C: 'ΑΣΦΑΛΙΣΤΙΚΗ',
  INSURANCE_PARTNERS: 'Συν.Ασφαλιστηκές',
  INSURANCES: 'Ασφαλιστικές',
  KEEPED_FOR: 'Κρατημένο για ',
  LICENSE_PLATE_BLUR: 'Θάμπωμα Πινακίδας',
  LIST: 'Λίστα',
  LOG_INTO_APPLICATION: 'Είσοδος στο Σύστημα',
  LOGIN: 'Εισοδος',
  LOGOUT: 'Αποσύνδεση',
  LOSES: 'Ήττες',
  MANAGE: 'Διαχείριση',
  MAX_FILE_SIZE: 'Μέγιστο μέγεθος αρχείου',
  MAX_LIMIT_OF_PHOTOS_REACHED: 'Μέγιστο όριο φωτογραφιών',
  MERCHANT: 'Έμπορος',
  MERCHANTS: 'Έμποροι',
  MERCHANT_OFFER: 'Προσφορά Εμπόρου',
  MINUTES: 'Λεπτά',
  MOBILE: 'Κινητό',
  MODAL_QUESTION_OFFER_DELETE: 'Η προσφορά σας θα διαγραφεί. Είστε σίγουρος;',
  MODAL_QUESTION_AUCTION_CANCEL: 'Η δημοπρασία θα ακυρωθεί. Είστε σίγουρος;',
  MODAL_QUESTION_OFFER_REJECT: 'Θέλετε να απορρίψετε την προσφορά σας;',
  MODAL_QUESTION_PARTS_SENT: 'Έχετε αποστείλει τα ανταλλακτικά;',
  MODAL_QUESTION_PARTS_SENT_PROBLEM:
    'Υπάρχει πρόβλημα με την αποστολή των ανταλλακτικών;',
  MODAL_QUESTION_GARAGE_DELETE: 'Πρόκειται να διαγράψετε το συνεργείο ',
  MODAL_QUESTION_PARTY_DELETE: 'Πρόκειται να διαγράψετε το πρόσωπο ',
  MODAL_QUESTION_PASSWORD_RESET: 'Πρόκειται να κάνετε reset το password του ',
  MODAL_QUESTION_PARTY_ACTIVATE: 'Πρόκειται να ενεργοποιήσετε το πρόσωπο ',
  MODAL_QUESTION_PARTY_DEACTIVATE: 'Πρόκειται να απενεργοποιήσετε το πρόσωπο ',
  MODEL: 'Μοντέλο',
  MONTH_JAN: 'Ιαν',
  MONTH_FEB: 'Φεβ',
  MONTH_MAR: 'Μαρ',
  MONTH_APR: 'Απρ',
  MONTH_MAY: 'Μαι',
  MONTH_JUN: 'Ιουν',
  MONTH_JUL: 'Ιουλ',
  MONTH_AUG: 'Αυγ',
  MONTH_SEP: 'Σεπ',
  MONTH_OCT: 'Οκτ',
  MONTH_NOV: 'Νοε',
  MONTH_DEC: 'Δεκ',
  MORE: 'Περισσότερα',
  NEW_AUCTION_IN_FOLDER: 'Νέο Ανταλλακτικό στον Ίδιο Φάκελο',
  NO: 'Όχι',
  NO_OFFER: 'Χωρίς Προσφορά',
  NO_OFFERS_CONTINUE: ' χωρίς προσφορές',
  NOT_AUTHORIZED_TO_VIEW_PAGE: 'Δεν έχετε δικαιώματα να δείτε αυτή τη σελίδα',
  NOT_VALID_AFM: 'Το ΑΦΜ δεν είναι έγκυρο.',
  NOT_VALID_AFM_TEMP: 'Το ΑΦΜ δεν μπορεί να έχει περισσότερα από 10 ψηφία.',
  NOT_VALID_EMAIL: 'Το Email δεν είναι έγκυρο.',
  NUMBER: 'Αριθμός',
  NAME_SURNAME: 'Ονομ/μο',
  OFFER: 'Προσφορά',
  OFFER_ACCEPTED_RESPONE:
    'Η ασφαλιστική επέλεξε την προσφορά σας! Παρακαλούμε αποδεχθείτε την επιλογή',
  OFFER_APPROVE: 'Αποδοχή Προσφοράς',
  OFFER_REJECT: 'Απόρριψη Προσφοράς',
  OFFER_APPROVE_ASK: 'Αποδέχεστε την προσφορά;',
  OFFER_C: 'ΠΡΟΣΦΟΡΑ',
  OFFER_CHOOSE_FOR: 'Έχετε επιλέξει προσφορά για ',
  OFFER_CHOSEN_FOR: 'Έχει επιλεχθεί προσφορά για ',
  OFFER_CHOSE_ONE_FROM_THEM: 'Επιλέξτε μια από τις παρακάτω προσφορές',
  OFFER_NEW: 'Νέα Προσφορά',
  OFFER_NEW_C: 'ΝΕΑ ΠΡΟΣΦΟΡΑ',
  OFFER_SELECTION: 'Επιλογή Προσφοράς',
  OFFER_FOR: 'Προσφορά για ',
  OFFER_ALREADY_FOR: 'Εχετε ήδη κάνει μια προσφορά για ',
  OFFER_WILL_BE_REPLACED: '. Αν συνεχίσετε η προσφορά σας θα αντικατασταθεί.',
  OFFER_STATUS: 'Κατάσταση Προσφορών',
  OFFERS: 'Προσφορές',
  OFFERS_INITIAL_PRICE_C: 'ΠΡΟΣΦΟΡΕΣ - ΑΡΧΙΚΗ ΤΙΜΗ: ',
  OFFERS_TO_AUCTIONS_C: 'ΠΡΟΣΦΟΡΕΣ ΣΕ ΔΗΜΟΠΡΑΣΙΕΣ',
  OR_CLICK_TO_UPLOAD: 'ή κάντε κλικ για να ανεβάσετε αρχείο',
  ORDER: 'Παραγγελία',
  OVERDUE: 'Έληξε',
  PART_C: 'ΑΝΤΑΛΛΑΚΤΙΚΟ',
  PART_DATA: 'Στοιχεία Ανταλλακτικού',
  PART_NO: 'Part No',
  PART_NUMBER: 'Αρ.Ανταλλακτικού',
  PART_SEND: 'Αποστολή Ανταλλακτικών',
  PART_SEND_PROBLEM: 'Πρόβλημα αποστολής ανταλλακτικών',
  PART_SEND_FINISHED_ASK: 'Έχει ολοκληρωθεί η παράδοση των ανταλλακτικών;',
  PART_TYPE: 'Τύπος',
  PART_TYPE_LONG: 'Τύπος Ανταλ.',
  PART_TYPE_IMITATION: 'After Market',
  PART_TYPE_IMITATION_SHORT: 'AFT',
  PART_TYPE_NEW: 'Γνήσιο',
  PART_TYPE_NEW_PL: 'Γνήσια',
  PART_TYPE_NEW_SHORT: 'ΓΝΣ',
  PART_TYPE_USED: 'Μεταχειρισμένο',
  PART_TYPE_USED_PL: 'Μεταχειρισμένα',
  PART_TYPE_USED_SHORT: 'ΜΤΧ',
  PART_TYPES: 'Τύποι Ανταλλακτικών',
  PART_WITH_PRICE: ' κομμάτι με τιμή ',
  PARTIES: 'Πρόσωπα',
  PARTICIPATE_TO: 'Σε Συμμετοχή',
  PARTS_PER_FOLDER: 'Ανταλλακτικά ανά Φάκελο',
  PARTS_DELIVERY: 'Τα ανταλλακτικά είναι για αποστολή',
  PARTS_DELIVERY_PROBLRM:
    'Υπάρχει πρόβλημα με την αποστολή των ανταλλακτικών. Δείτε τα σχόλια.',
  PARTY_EDIT_C: 'ΕΠΕΞΕΡΓΑΣΙΑ ΠΡΟΣΩΠΟΥ',
  PARTY_DELETE: 'Διαγραφή προσώπου',
  PARTY_NEW_C: 'ΕΠΕΞΕΡΓΑΣΙΑ ΠΡΟΣΩΠΟΥ',
  PARTY_STATUS: 'Κατάσταση',
  PARTY_TYPE: 'Τύπος',
  PASSWORD: 'Κωδικός',
  PASSWORD_NEW: 'Νέος Κωδικός',
  PASSWORD_OLD: 'Παλιός Κωδικός',
  PENDING_APPROVAL: 'Προς Έγκριση',
  PER_BRAND: 'Ανά Μάρκα',
  PER_EXPERT: 'Ανά Εμπειρογνώμονα',
  PER_INSURANCE: 'Ανά Ασφαλιστική',
  PER_MODEL: 'Ανά Μοντέλο',
  PER_PART_TYPE: 'Ανά Τύπο Ανταλλακτικού',
  PER_REGION: 'Ανά Νομό',
  PERIOD: 'Περίοδος',
  PERIOD_WEEKLY: 'Εβδομαδιαία',
  PERIOD_MONTHLY: 'Μηνιαία',
  PERIOD_QUARTERLY: 'Τριμηνιαία',
  PERIOD_THIRD_YEARLY: 'Τετραμηνιαία',
  PERIOD_HALF_YEARLY: 'Εξαμηνιαία',
  PERIOD_YEARLY: 'Ετήσια',
  PROFILE: 'Προφίλ',
  PROFILE_C: 'ΠΡΟΦΙΛ',
  POSTALCODE: 'ΤΚ',
  PHONE: 'Τηλέφωνο',
  PHONE_SHORT: 'Τηλ',
  PHOTOS: 'Φωτογραφίες',
  PLATE: 'Πινακίδα',
  PLATE_NUMBER: 'Αρ.Κυκλοφορίας',
  PREFECTURE: 'Νομός',
  PRICE: 'Τιμή',
  PRICE_IMITATION: 'Τιμή After Market',
  PRICE_IMITATION_TARGET: 'Ενδ. Τιμή After Market',
  PRICE_NEW: 'Τιμή Γνήσιου',
  PRICE_NEW_TARGET: 'Ενδ. Τιμή Γνήσιου',
  PRICE_USED: 'Τιμή Μεταχειρισμένου',
  PRICE_USED_TARGET: 'Ενδ. Τιμή Μεταχειρισμένου',
  QUANTITY: 'Ποσότητα',
  REGISTRATION_YEAR: 'Έτος Κυκλ.',
  REGION: 'Νομός',
  REGIONS: 'Νομοί',
  REJECTED_PL_FEM: 'Απορριφθείσες',
  REJECTION: 'Απόρριψη',
  REMAINING_TIME_SHORT: 'Υπ. Χρόνος',
  REPORT_NO_BRAND: '<Χωρίς Μάρκα>',
  REPORT_NO_EXPERT: '<Χωρίς Εμπειρογνώμονα>',
  REPORT_NO_INSURANCE: '<Χωρίς Ασφαλιστική>',
  REPORT_NO_REGION: '<Χωρίς Νομό>',
  REPORTS: 'Στατιστικά',
  REORDER: 'Αλλαγή Σειράς',
  RESET_PASSWOD: 'Reset Password',
  RETURN: 'Επιστροφή',
  SAVE: 'Αποθήκευση',
  SAVE_INPUT: 'Καταχώρηση',
  SECONDS: 'Δεύτερα',
  SELECT: 'Επιλογή',
  SELECT_C: 'ΕΠΙΛΟΓΗ',
  SELECTION: 'Επιλογή',
  SEMESTER_COUNT: 'o εξάμηνο ',
  SETTINGS: 'Ρυθμίσεις',
  SN: 'A/A',
  STATUS: 'Κατάσταση',
  STREET: 'Οδός',
  SUM_INITIAL_PRICE: 'Σύνολο Αρχ.Τιμής',
  SURNAME: 'Επώνυμο',
  TAXNUMBER: 'ΑΦΜ',
  TAXOFFICE: 'ΔΟΥ',
  TEMP_SELECT: 'Επιλογή',
  TITLE: 'Επωνυμία',
  TODAY: 'Σήμερα',
  TOMORROW: 'Αύριο',
  TOTAL: 'Σύνολο',
  TOTAL_AMOUNT: 'Συνολικό Ποσό',
  TOTAL_INITIAL_PRICE: 'Σύνολο Αρχ.Τιμή',
  UPLOAD_COMPLETE: 'Επιτυχής Μεταφόρτωση!',
  UPLOADING: 'Πραγματοποιείται μεταφόρτωση...',
  USED_CONDITION_TYPE: 'Κατ. Μεταχειρισμένου',
  USERNAME: 'Όνομα Χρήστη',
  VDPARTS: 'VD-Parts',
  VDCARS: 'VD-Cars',
  VEHICLE_DATA: 'Στοιχεία Οχήματος',
  VIEW_ALL: 'Προβολή Όλων',
  VIEW_ALL_C: 'ΠΡΟΒΟΛΗ ΟΛΩΝ',
  YEAR_CREATED: 'Έτος Κυκλοφορίας',
  YES: 'Ναι',
  WAITING_FOR_ACCEPT_FROM_MERCHANT: 'Σε αναμονή για αποδοχή από αντιπρόσωπο',
  WINNINGS: 'Κέρδη',
  WINS: 'Νίκες',
  WITH_INITIAL_PRICE: 'με αρχική αξια',
  WITHOUT_OFFER: 'Χωρίς Προσφορά',
  WRONG_USERNAME_OR_PASSWORD: 'Λάθος όνομα χρήστη ή κωδικός.',

  //UsedConditionTypes
  PERFECT: 'Άριστη',
  VERY_GOOD: 'Πολύ Καλή',
  FUNCTIONAL: 'Λειτουργικό',
  NEED_REPAIR: 'Χρήζει επιδιόρθωση',

  //ImitationPartCategories
  CATEGORY_A: 'Ά Κατηγορίας',
  CATEGORY_B: '΄Β Κατηγορίας',

  //PREFECTURES
  ATTIKI: 'ΑΤΤΙΚΗΣ',
  THESSALONIKIS: 'ΘΕΣΣΑΛΟΝΙΚΗΣ',
  ACHAIAS: 'ΑΧΑΪΑΣ',
  HERAKLION: 'ΗΡΑΚΛΕΊΟΥ',
  LARISAS: 'ΛΑΡΙΣΑΣ',
  AITOLOAKARNANIAS: 'ΑΙΤΩΛΟΑΚΑΡΝΑΝΙΑΣ',
  EVOIAS: 'ΕΥΒΟΙΑΣ',
  MAGNISIAS: 'ΜΑΓΝΗΣΙΑΣ',
  SERRON: 'ΣΕΡΡΩΝ',
  ILIAS: 'ΗΛΕΙΑΣ',
  DODEKANISOU: 'ΔΩΔΕΚΑΝΗΣΟΥ',
  FTHIOTIDAS: 'ΦΘΙΩΤΙΔΑΣ',
  MESSINIAS: 'ΜΕΣΣΗΝΙΑΣ',
  IOANNINON: 'ΙΩΑΝΝΙΝΩΝ',
  KOZANIS: 'ΚΟΖΑΝΗΣ',
  KORINTHIAS: 'ΚΟΡΙΝΘΙΑΣ',
  CHANION: 'ΧΑΝΙΩΝ',
  EVROU: 'ΕΒΡΟΥ',
  PELLAS: 'ΠΕΛΛΑΣ',
  KAVALAS: 'ΚΑΒΑΛΑΣ',
  IMATHIAS: 'ΗΜΑΘΙΑΣ',
  TRIKALON: 'ΤΡΙΚΑΛΩΝ',
  VIOTIAS: 'ΒΙΩΤΙΑΣ',
  PIERIAS: 'ΠΙΕΡΙΑΣ',
  KARDITSAS: 'ΚΑΡΔΙΤΣΑΣ',
  KYKLADON: 'ΚΥΚΛΑΔΩΝ',
  KERKYRAS: 'ΚΕΡΚΥΡΑΣ',
  RODOPIS: 'ΡΟΔΟΠΗΣ',
  LESVOU: 'ΛΕΣΒΟΥ',
  ARGOLIDAS: 'ΑΡΓΟΛΙΔΑΣ',
  CHALKIDIKIS: 'ΧΑΛΚΙΔΙΚΗΣ',
  DRAMAS: 'ΔΡΑΜΑΣ',
  ARKADIAS: 'ΑΡΚΑΔΙΑΣ',
  XANTHIS: 'ΞΑΝΘΗΣ',
  LAKONIAS: 'ΛΑΚΩΝΙΑΣ',
  KILKIS: 'ΚΙΛΚΙΣ',
  RETHIMNOU: 'ΡΕΘΥΜΝΟΥ',
  ARTAS: 'ΑΡΤΑΣ',
  LASITHIOU: 'ΛΑΣΙΘΙΟΥ',
  PREVEZAS: 'ΠΡΕΒΕΖΑΣ',
  FLORINAS: 'ΦΛΩΡΙΝΑΣ',
  KASTORIAS: 'ΚΑΣΤΟΡΙΑΣ',
  CHIOU: 'ΧΙΟΥ',
  FOKIDAS: 'ΦΩΚΙΔΑΣ',
  THESPROTIAS: 'ΘΕΣΠΡΩΤΙΑΣ',
  SAMOU: 'ΣΑΜΟΥ',
  KEFALLINIAS: 'ΚΕΦΑΛΛΗΝΙΑΣ',
  ZAKINTHOU: 'ΖΑΚΥΝΘΟΥ',
  GREVENON: 'ΓΡΕΒΕΝΩΝ',
  EVRITANIAS: 'ΕΥΡΥΤΑΝΙΑΣ',
  LEFKADAS: 'ΛΕΥΚΑΔΑΣ',
  FAMAGUSTA: 'ΑΜΜΟΧΩΣΤΟΣ',
  KYRENIA: 'ΚΕΡΥΝΕΙΑ',
  LARNACA: 'ΛΑΡΝΑΚΑ',
  LIMASSOL: 'ΛΕΜΕΣΟΣ',
  NICOSIA: 'ΛΕΥΚΩΣΙΑ',
  PAPHOS: 'ΠΑΦΟΣ',

  //Countries
  ANDORRA: 'ΑΝΔΟΡΡΑ',
  UNITED_ARAB_EMIRATES: 'ΗΝΩΜΕΝΑ ΑΡΑΒΙΚΑ ΕΜΙΡΑΤΑ',
  AFGHANISTAN: 'ΑΦΓΑΝΙΣΤΑΝ',
  ANTIGUA_AND_BARBUDA: 'ΑΝΤΙΓΚΟΥΑ ΚΑΙ ΜΠΑΡΜΠΟΥΝΤΑ',
  ANGUILLA: 'ΑΝΓΚΟΥΙΛΛΑ',
  ALBANIA: 'ΑΛΒΑΝΙΑ',
  ARMENIA: 'ΑΡΜΕΝΙΑ',
  NETHERLANDS_ANTILLES: 'ΟΛΛΑΝΔΙΚΕΣ ΑΝΤΙΛΛΕΣ',
  ANGOLA: 'ΑΓΓΟΛΑ',
  ARGENTINA: 'ΑΡΓΕΝΤΙΝΗ',
  AMERICAN_SAMOA: 'ΑΜΕΡΙΚΑΝΙΚΗ ΣΑΜΟΑ',
  AUSTRIA: 'ΑΥΣΤΡΙΑ',
  AUSTRALIA: 'ΑΥΣΤΡΑΛΙΑ',
  ARUBA: 'ΑΡΟΥΜΠΑ',
  AZERBAIJAN: 'ΑΖΕΡΜΠΑΪΤΖΑΝ',
  BOSNIA_AND_HERZEGOVINA: 'ΒΟΣΝΙΑ-ΕΡΖΕΓΟΒΙΝΗ',
  BARBADOS: 'ΜΠΑΡΜΠΑΝΤΟΣ',
  BANGLADESH: 'ΜΠΑΓΚΛΑΝΤΕΣ',
  BELGIUM: 'ΒΕΛΓΙΟ',
  BURKINA_FASO: 'ΜΠΟΥΡΚΙΝΑ ΦΑΣΟ',
  BULGARIA: 'ΒΟΥΛΓΑΡΙΑ',
  BAHRAIN: 'ΜΠΑΧΡΕΙΝ',
  BURUNDI: 'ΜΠΟΥΡΟΥΝΤΙ',
  BENNIN: 'ΜΠΕΝΝΙΝ',
  SHORTS: 'ΒΕΡΜΟΥΔΕΣ',
  BRUNEI_DARUSSALAM: 'ΜΠΡΟΥΝΕΙ ΝΤΑΡΟΥΣΑΛΑΜ',
  BOLIVIA: 'ΒΟΛΙΒΙΑ',
  BRAZIL: 'ΒΡΑΖΙΛΙΑ',
  BAHAMAS: 'ΜΠΑΧΑΜΕΣ',
  BHUTAN: 'ΜΠΟΥΤΑΝ',
  Bouvet_ISLAND: 'ΜΠΟΥΒΕ ΝΗΣΙ',
  BOTSWANA: 'ΜΠΟΤΣΟΥΑΝΑ',
  BELARUS: 'ΛΕΥΚΟΡΩΣΣΙΑ',
  BELIZE: 'ΜΠΕΛΙΖ',
  CANADA: 'ΚΑΝΑΔΑΣ',
  KILLINGK_ISLANDS: 'ΚΗΛΛΙΝΓΚ ΝΗΣΙΑ',
  DEMOCRATIC_REPUBLIC_OF_CONGO: 'ΛΑΪΚΗ ΔΗΜΟΚΡΑΤΙΑ ΤΟΥ ΚΟΝΓΚΟ',
  CENTRAL_AFRICA: 'ΚΕΝΤΡΙΚΗ ΑΦΡΙΚΗ',
  CONGO: 'ΚΟΝΓΚΟ',
  SWITZERLAND: 'ΕΛΒΕΤΙΑ',
  IVORY_COAST: 'ΑΚΤΗ ΕΛΕΦΑΝΤΟΣΤΟΥ',
  COOK_ISLANDS: 'ΚΟΥΚ ΝΗΣΙΑ',
  CHILE: 'ΧΙΛΗ',
  CAMEROON: 'ΚΑΜΕΡΟΥΝ',
  CHINA: 'ΚΙΝΑ',
  COLOMBIA: 'ΚΟΛΟΜΒΙΑ',
  COSTA_RICA: 'ΚΟΣΤΑ ΡΙΚΑ',
  CUBA: 'ΚΟΥΒΑ',
  CAPE_VERDE: 'ΠΡΑΣΙΝΟ ΑΚΡΩΤΗΡΙΟ',
  CHRISTMAS_ISLAND: 'ΧΡΙΣΤΟΥΓΕΝΝΩΝ ΝΗΣΙΑ',
  CYPRUS: 'ΚΥΠΡΟΣ',
  CZECH_REPUBLIC: 'ΤΣΕΧΙΑ',
  GERMANY: 'ΓΕΡΜΑΝΙΑ',
  DJIBOUTI: 'ΤΖΙΜΠΟΥΤΙ',
  DENMARK: 'ΔΑΝΙΑ',
  DOMINICA: 'ΝΤΟΜΙΝΙΚΑ',
  DOMINICAN_REPUBLIC: 'ΑΓΙΟΣ ΔΟΜΙΝΙΚΟΣ',
  ALGERIA: 'ΑΛΓΕΡΙΑ',
  ECUADOR: 'ΙΣΗΜΕΡΙΝΟΣ',
  ESTONIA: 'ΕΣΘΟΝΙΑ',
  EGYPT: 'ΑΙΓΥΠΤΟΣ',
  WEST_SAHARA: 'ΔΥΤΙΚΗ ΣΑΧΑΡΑ',
  SPAIN: 'ΙΣΠΑΝΙΑ',
  AITHIOPOIA: 'ΑΙΘΙΟΠΟΙΑ',
  FINLAND: 'ΦΙΝΛΑΝΔΙΑ',
  FIJI: 'ΦΙΤΖΙ',
  FALKLAND_ISLANDS: 'ΦΩΚΛΑΝΤ ΝΗΣΙΑ',
  MICRONESIA: 'ΜΙΚΡΟΝΗΣΙΑ',
  AEGEAN_ISLANDS: 'ΦΕΡΟΕΣ ΝΗΣΙΑ',
  FRANCE: 'ΓΑΛΛΙΑ',
  GABON: 'ΓΚΑΜΠΟΝ',
  UNITED_KINGDOM: 'ΗΝΩΜΕΝΟ ΒΑΣΙΛΕΙΟ',
  GRENADA: 'ΓΡΕΝΑΔΑ',
  GEORGIA: 'ΓΕΩΡΓΙΑ',
  FRENCH_GUYANA: 'ΓΑΛΛΙΚΗ ΓΟΥΙΑΝΑ',
  GKOUERNSEF: 'ΓΚΟΥΕΡΝΣΕΥ',
  GHANA: 'ΓΚΑΝΑ',
  GIBRALTAR: 'ΓΙΒΡΑΛΤΑΡ',
  GREENLAND: 'ΓΡΟΙΛΑΝΔΙΑ',
  GAMBIA: 'ΓΚΑΜΠΙΑ',
  GUINEA: 'ΓΟΥΙΝΕΑ',
  GUADELOUPE: 'ΓΟΥΑΔΕΛΟΥΠΗ',
  EQUATORIAL_GUINEA: 'ΙΣΗΜΕΡΙΝΗ ΓΟΥΙΝΕΑ',
  GREECE: 'ΕΛΛΑΔΑ',
  GUATEMALA: 'ΓΟΥΑΤΕΜΑΛΑ',
  GUAM: 'ΓΚΟΥΑΜ',
  GUINEA_BISSAU: 'ΓΟΥΙΝΕΑ ΜΠΙΣΣΑΟΥ',
  GUYANA: 'ΓΟΥΙΑΝΑ',
  HONG_KONG: 'ΧΟΝΓΚ ΚΟΝΓΚ',
  HEARD_ISLAND_AND_McDONALD_ISLAND: 'ΧΕΡΝΤ ΝΗΣΙ ΚΑΙ ΜΑΚ ΝΤΟΝΑΛΝΤ ΝΗΣΙ',
  HONDURAS: 'ΟΝΔΟΥΡΑ',
  CROATIA: 'ΚΡΟΑΤΙΑ',
  HAITI: 'ΑΪΤΗ',
  HUNGARY: 'ΟΥΓΓΑΡΙΑ',
  INDONESIA: 'ΙΝΔΟΝΗΣΙΑ',
  IRELAND: 'ΙΡΛΑΝΔΙΑ',
  ISRAEL: 'ΙΣΡΑΗΛ',
  ISLE_OF_MAN: 'ΝΗΣΟΣ ΜΑΝ',
  INDIA: 'ΙΝΔΙΑ',
  BRITISH_INDIAN_OCEAN_REGION: 'ΒΡΕΤΑΝΙΚΗ ΠΕΡΙΟΧΗ ΤΟΥ ΙΝΔΙΚΟΥ ΩΚΕΑΝΟΥ',
  IRAQ: 'ΙΡΑΚ',
  IRAN: 'ΙΡΑΝ',
  ICELAND: 'ΙΣΛΑΝΔΙΑ',
  ITALY: 'ΙΤΑΛΙΑ',
  JERSEY: 'ΤΖΕΡΣΕΥ',
  JAMAICA: 'ΤΖΑΜΑΙΚΑ',
  JORDAN: 'ΙΟΡΔΑΝΙΑ',
  JAPAN: 'ΙΑΠΩΝΙΑ',
  KENYA: 'ΚΕΝΥΑ',
  KYRGISTAN: 'ΚΥΡΓΙΣΤΑΝ',
  CAMBODIA: 'ΚΑΜΠΟΤΖΗ',
  KIRIBATI: 'ΚΙΡΙΜΠΑΤΙ',
  COMOROS: 'ΚΟΜΟΡΕΣ',
  SAINT_KITTS_AND_NEVIS: 'ΑΓΙΟΣ ΧΡΙΣΤΟΦΟΡΟΣ ΚΑΙ ΝΕΒΙΣ',
  NORTH_KOREA: 'ΒΟΡΕΙΑ ΚΟΡΕΑ',
  SOUTH_KOREA: 'ΝΟΤΙΑ ΚΟΡΕΑ',
  KUWAIT: 'ΚΟΥΒΕΙΤ',
  Cayman_ISLANDS: 'ΚΑΫΜΑΝ ΝΗΣΙΑ',
  KAZAKHSTAN: 'ΚΑΖΑΚΣΤΑΝ',
  LAOS: 'ΛΑΟΣ',
  LEBANON: 'ΛΙΒΑΝΟΣ',
  SAINT_LUCIA: 'ΑΓΙΑ ΛΟΥΚΙΑ',
  LIECHTENSTEIN: 'ΛΙΧΤΕΝΣΤΑΙΝ',
  SRI_LANKA: 'ΣΡΙ ΛΑΝΚΑ',
  LIBERIA: 'ΛΙΒΕΡΙΑ',
  LESOTHO: 'ΛΕΣΟΘΟ',
  LITHUANIA: 'ΛΙΘΟΥΑΝΙΑ',
  LUXEMBOURG: 'ΛΟΥΞΕΜΒΟΥΡΓΟ',
  LATVIA: 'ΛΕΤΤΟΝΙΑ',
  LIBYA: 'ΛΙΒΥΗ',
  MOROCCO: 'ΜΑΡΟΚΟ',
  MONACO: 'ΜΟΝΑΚΟ',
  MOLDOVA: 'ΜΟΛΔΑΒΙΑ',
  MONTENEGRO: 'ΜΑΥΡΟΒΟΥΝΙΟ',
  MADAGASCAR: 'ΜΑΔΑΓΑΣΚΑΡΗ',
  MARSHALL_ISLANDS: 'ΜΑΡΣΑΛΛ ΝΗΣΙΑ',
  FYR_of_MACEDONIA: 'ΣΚΟΠΙΑ',
  MALI: 'ΜΑΛΙ',
  MYANMAR: 'ΜΥΑΝΜΑΡ',
  MONGOLIA: 'ΜΟΓΓΟΛΙΑ',
  MACAU: 'ΜΑΚΑΟ',
  NORTHERN_ISLANDS_MARIANNES: 'ΒΟΡΕΙΕΣ ΜΑΡΙΑΝΝΕΣ ΝΗΣΙΑ',
  MARTINIQUE: 'ΜΑΡΤΙΝΙΚΑ',
  MAURITANIA: 'ΜΑΥΡΙΤΑΝΙΑ',
  MONTSERRAT: 'ΜΟΝΤΣΕΡΡΑΤ',
  MALTA: 'ΜΑΛΤΑ',
  MAURITIUS: 'ΜΑΥΡΙΚΙΟΣ',
  MALDIVES: 'ΜΑΛΔΙΒΕΣ',
  MALAWI: 'ΜΑΛΑΟΥΙ',
  MEXICO: 'ΜΕΞΙΚΟ',
  MALAYSIA: 'ΜΑΛΑΙΣΙΑ',
  MOZAMBIQUE: 'ΜΟΖΑΜΒΙΚΗ',
  NAMIBIA: 'ΝΑΜΙΜΠΙΑ',
  NEW_CALEDONIA: 'ΝΕΑ ΚΑΛΗΔΟΝΙΑ',
  NIGER: 'ΝΙΓΗΡ',
  NORFOLK_ISLAND: 'ΝΟΡΦΟΛΚ ΝΗΣΙΑ',
  NIGERIA: 'ΝΙΓΗΡΙΑ',
  NICARAGUA: 'ΝΙΚΑΡΑΓΟΥΑ',
  NETHERLANDS: 'ΟΛΛΑΝΔΙΑ',
  NORWAY: 'ΝΟΡΒΗΓΙΑ',
  NEPAL: 'ΝΕΠΑΛ',
  NAURU: 'ΝΑΟΥΡΟΥ',
  NIUE: 'ΝΙΟΥΕ',
  NEW_ZEALAND: 'ΝΕΑ ΖΗΛΑΝΔΙΑ',
  OMAN: 'ΟΜΑΝ',
  PANAMA: 'ΠΑΝΑΜΑΣ',
  PERU: 'ΠΕΡΟΥ',
  FRENCH_POLYNESIA: 'ΓΑΛΛΙΚΗ ΠΟΛΥΝΗΣΙΑ',
  PAPUA_NEW_GUINEA: 'ΠΑΠΟΥΑ ΝΕΑ ΓΟΥΙΝΕΑ',
  PHILIPPINES: 'ΦΙΛΙΠΠΙΝΕΣ',
  PAKISTAN: 'ΠΑΚΙΣΤΑΝ',
  POLAND: 'ΠΟΛΩΝΙΑ',
  SAINT_PIERRE_AND_MIQUELON: 'ΑΓΙΟΣ ΠΕΤΡΟΣ ΚΑΙ ΜΙΚΕΛΟΝ',
  PITCAIRN: 'ΠΙΤΚΑΙΡΝ',
  PUERTO_RICO: 'ΠΟΥΕΡΤΟ ΡΙΚΟ',
  PALESTINE: 'ΠΑΛΑΙΣΤΙΝΗ',
  PORTUGAL: 'ΠΟΡΤΟΓΑΛΙΑ',
  PALAU: 'ΠΑΛΑΟΥ',
  PARAGUAY: 'ΠΑΡΑΓΟΥΑΗ',
  QATAR: 'ΚΑΤΑΡ',
  REUNIFICATION_ISLANDS: 'ΕΠΑΝΕΝΩΣΗΣ ΝΗΣΙΑ',
  ROMANIA: 'ΡΟΥΜΑΝΙΑ',
  SERBIA: 'ΣΕΡΒΙΑ',
  RUSSIA: 'ΡΩΣΣΙΑ',
  RWANDA: 'ΡΟΥΑΝΤΑ',
  SAUDI_ARABIA: 'ΣΑΟΥΔΙΚΗ ΑΡΑΒΙΑ',
  SOLOMONTA_ISLANDS: 'ΣΟΛΩΜΩΝΤΑ ΝΗΣΙΑ',
  SEYCHELLES: 'ΣΕΫΧΕΛΛΕΣ',
  SUDAN: 'ΣΟΥΔΑΝ',
  SWEDEN: 'ΣΟΥΗΔΙΑ',
  SINGAPORE: 'ΣΙΓΚΑΠΟΥΡΗ',
  SAINT_HELENA: 'ΑΓΙΑ ΕΛΕΝΗ',
  SLOVENIA: 'ΣΛΟΒΕΝΙΑ',
  SFALMPARNT_AND_JAN_MAYEN: 'ΣΦΑΛΜΠΑΡΝΤ ΚΑΙ ΓΙΑΝ ΜΑΓΙΕΝ',
  SLOVAKIA: 'ΣΛΟΒΑΚΙΑ',
  SIERRA_LEONE: 'ΣΙΕΡΡΑ ΛΕΟΝΕ',
  SAN_MARINO: 'ΑΓΙΟΣ ΜΑΡΙΝΟΣ',
  SENEGAL: 'ΣΕΝΕΓΑΛΗ',
  SOMALIA: 'ΣΟΜΑΛΙΑ',
  SURINAME: 'ΣΟΥΡΙΝΑΜ',
  SAINT_THOMAS_AND_PRINCE: 'ΑΓΙΟΣ ΘΩΜΑΣ ΚΑΙ ΠΡΙΓΚΗΠΑΣ',
  EL_SALVADOR: 'ΕΛ ΣΑΛΒΑΔΟΡ',
  SYRIA: 'ΣΥΡΙΑ',
  SOUAZILANDI: 'ΣΟΥΑΖΙΛΑΝΔΗ',
  TURKS_AND_CAICOS_ISLANDS: 'ΤΟΥΡΚΩΝ ΚΑΙ ΚΑΙΚΟΣ ΝΗΣΙΑ',
  CHAD: 'ΤΣΑΝΤ',
  FRENCH_SOUTHERN_AREAS: 'ΓΑΛΛΙΚΕΣ ΝΟΤΙΕΣ ΠΕΡΙΟΧΕΣ',
  TOGO: 'ΤΟΓΚΟ',
  THAILAND: 'ΤΑΪΛΑΝΔΗ',
  TAJIKISTAN: 'ΤΑΤΖΙΚΙΣΤΑΝ',
  TOKELAU: 'ΤΟΚΕΛΑΟΥ',
  EAST_TIMOR: 'ΑΝΑΤΟΛΙΚΟ ΤΙΜΟΡ',
  TURKMENISTAN: 'ΤΟΥΡΚΜΕΝΙΣΤΑΝ',
  TUNISIA: 'ΤΥΝΗΣΙΑ',
  TONGA: 'ΤΟΝΓΚΑ',
  TURKEY: 'ΤΟΥΡΚΙΑ',
  TRINITAD_AND_TOBAGO: 'ΤΡΙΝΙΤΑΔ ΚΑΙ ΤΟΜΠΑΓΚΟ',
  TUVALU: 'ΤΟΥΒΑΛΟΥ',
  TAIWAN_PROVINCE_OF_CHINA: 'ΤΑΪΒΑΝ ΕΠΑΡΧΙΑ ΤΗΣ ΚΙΝΑΣ',
  TANZANIA: 'ΤΑΝΖΑΝΙΑ',
  UKRAINE: 'ΟΥΚΡΑΝΙΑ',
  UGANDA: 'ΟΥΓΚΑΝΤΑ',
  UNITED_STATES_ELASSONA_OUTLYING_ISLANDS:
    'ΗΝΩΜΕΝΩΝ ΠΟΛΙΤΕΙΩΝ ΕΛΑΣΣΟΝΑ ΕΞΩΤΕΡΙΚΑ ΝΗΣΙΑ',
  UNITED_STATES: 'ΗΝΩΜΕΝΕΣ ΠΟΛΙΤΕΙΕΣ',
  URUGUAY: 'ΟΥΡΟΥΓΟΥΑΗ',
  UZBEKISTAN: 'ΟΥΖΜΠΕΚΙΣΤΑΝ',
  VATICAN: 'ΒΑΤΙΚΑΝΟ',
  SAINT_VINCENT_AND_THE_GRENADINES: 'ΑΓΙΟΣ ΒΙΚΕΝΤΙΟΣ ΚΑΙ ΓΡΕΝΑΔΙΝΕΣ',
  VENEZUELA: 'ΒΕΝΕΖΟΥΕΛΑ',
  VIRGIN_ISLANDS_BRITISH: 'ΠΑΡΘΕΝΑ ΝΗΣΙΑ ΒΡΕΤΑΝΙΚΑ',
  VIRGIN_ISLANDS_US: 'ΠΑΡΘΕΝΑ ΝΗΣΙΑ Η.Π.Α',
  VIETNAM: 'ΒΙΕΤΝΑΜ',
  VANUATU: 'ΒΑΝΟΥΑΤΟΥ',
  GOUOLLIS_AND_FUTUNA_ISLANDS: 'ΓΟΥΩΛΛΙΣ ΚΑΙ ΦΟΥΤΟΥΝΑ ΝΗΣΙΑ',
  SAMOES: 'ΣΑΜΟΕΣ',
  YEMEN: 'ΥΕΜΕΝΗ',
  SOUTH_AFRICA: 'ΝΟΤΙΑ ΑΦΡΙΚΗ',
  ZAMBIA: 'ΖΑΜΠΙΑ',
  ZIMBABWE: 'ΖΙΜΠΑΜΠΟΥΕ',
  REST: 'ΛΟΙΠΑΙ',
  ANTARCTICA: 'ΑΝΤΑΡΚΤΙΚΗ',
  AALAND_MISIA: 'ΑΑΛΑΝΤ ΜΗΣΙΑ',
  SAINT_BARTHOLOMEW: 'ΑΓΙΟΣ ΒΑΡΘΟΛΟΜΑΙΟΣ',
  BONAIRE_AND_SABA_SAINT_EFSTATHIOS: 'ΜΠΟΝΕΡ, ΑΓΙΟΣ ΕΥΣΤΑΘΙΟΣ ΚΑΙ ΣΑΜΠΑ',
  CURACAO: 'ΚΟΥΡΑΚΑΟ',
  ERITREA: 'ΕΡΥΘΡΑΙΑ',
  SOUTH_GEORGIA_AND_SOUTH_SANDWICH_ISLANDS:
    'ΝΟΤΙΑ ΓΕΩΡΓΙΑ ΚΑΙ ΝΟΤΙΑ ΣΑΝΤΟΥΙΤΣ ΝΗΣΙΑ',
  SAINT_MARTIN_FRENCH_PART: 'ΑΓΙΟΣ ΜΑΡΤΙΝΟΣ(ΓΑΛΛΙΚΟ ΤΜΗΜΑ)',
  SAINT_MARTIN_Dutch_part: 'ΑΓΙΟΣ ΜΑΡΤΙΝΟΣ(ΟΛΛΑΝΔΙΚΟ ΤΜΗΜΑ)',
  MAYOTTE: 'ΜΑΓΙΟΤ',
};

export default translations;
